import { render, staticRenderFns } from "./setMaterial1.vue?vue&type=template&id=ad8224b8&"
import script from "./setMaterial1.vue?vue&type=script&lang=js&"
export * from "./setMaterial1.vue?vue&type=script&lang=js&"
import style0 from "./setMaterial1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports